import React from 'react';
import {  Box, Grid, TextField, Button, Typography } from '@mui/material';
import SingleAccordion from '../../components/SingleAccordion';
import JobTask from '../../components/Mechanic/JobTask';
import HeaderBox from '../../components/HeaderBox';
import SpareParts from '../../components/Mechanic/SpareParts';
import buttonStyle from '../../styles/buttonStyle'
import { useNavigate } from 'react-router-dom';

const boxStyle = {
    root: {
      backgroundColor: 'white', 
      borderRadius: '5px',
      padding: 1
    },
  };
// const dataGridStyle = {
//     root: {
//       "& .MuiDataGrid-root": {
//         borderRadius: '10px',
//         backgroundColor: 'white',
//         fontSize: '15px',
//       },
//       "& .MuiDataGrid-columnHeaders": {
//         color: '#005A9C',
//         fontSize: '16px',
//       }
//     },
// };

function MechanicOrderUpdate() {
    const navigate = useNavigate()
  return (
    
    <Box mt={2}>
        <Grid container spacing={1}>
        <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}> MECHANIC ORDER UPDATE</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
            <Button sx={buttonStyle.root} onClick={() => navigate('/mechanic_order_update')}>Save</Button>&nbsp;
            <Button sx={buttonStyle.root} onClick={() => navigate('/mechanic_home')}>Cancel</Button>
          </Grid>
          </Grid>
        </Grid>

                <Grid item xs={12} >
                    <HeaderBox title='Service Order Update By Mechanic'/>
                </Grid>

                <Box sx={boxStyle.root}>
                    <form>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} md={1} mt={1}>
                                        <TextField fullWidth size='small' label= 'Mr/Mrs' variant="outlined"required name='Mr/Mrs' />
                                    </Grid> 
                                    <Grid item xs={12} sm={12} md={5.5} mt={1}>
                                        <TextField fullWidth size='small' label= 'First Name' variant="outlined"required name='First Name' />
                                    </Grid> 
                                    <Grid item xs={12} sm={12} md={5.5} mt={1}>
                                        <TextField fullWidth size='small' label= 'Last Name' variant="outlined"required name='Last Name' />
                                    </Grid>  
                                    <Grid item xs={12} sm={6} md={4} mt={1}>
                                        <TextField fullWidth size='small' label= 'Registration NO' variant="outlined"required name='Registration NO' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={4} mt={1}>
                                        <TextField fullWidth size='small' label= 'Make' variant="outlined"required name='Make' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={4} mt={1}>
                                        <TextField fullWidth size='small' label= 'Model' variant="outlined"required name='Model' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={4} mt={1}>
                                        <TextField fullWidth size='small' label= 'Service Order No' variant="outlined"required name='Service Order No' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={4} mt={1}>
                                        <TextField fullWidth size='small' label= 'Service Order Date' variant="outlined"required name='Service Order Date' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={4} mt={1}>
                                        <TextField fullWidth size='small' label= 'Service Order Type' variant="outlined"required name='Service Order Type' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={3.5} mt={1}>
                                        <TextField fullWidth size='small' label= 'Work Allocation Date' variant="outlined"required name='Work Allocation Date' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={3.5} mt={1}>
                                        <TextField fullWidth size='small' label= 'Work Start Date' variant="outlined"required name='Work Start Date' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={3.5} mt={1}>
                                        <TextField fullWidth size='small' label= 'Work Completion Date' variant="outlined"required name='Work Completion Date' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={1.5} mt={1}>
                                        <TextField fullWidth size='small' label= 'Total Hours' variant="outlined"required name='Total Hours' />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={6} mt={1}>
                                        <TextField fullWidth size='small' label= 'Advice From Supervisor' variant="outlined"required name='Advice From Supervisor' inputProps={{style: {height: '50px'}}}  multiline/>
                                    </Grid> 
                                    <Grid item xs={12} sm={6} md={6} mt={1}>
                                        <TextField fullWidth size='small' label= 'Comments From Mechanic' variant="outlined"required name='Comments From Mechanic' inputProps={{style: {height: '50px'}}} multiline />
                                    </Grid> 
                                    <Grid item xs={12}>
                                    <HeaderBox title=' << Display Allotted Task And Relted Parts >>'/>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <SingleAccordion component={<JobTask/>} title='Job Tasks'/>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <SingleAccordion component={<SpareParts/>} title=' Spare Parts'/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </form>
                </Box>
        </Grid>
    </Box>
  )
}

export default MechanicOrderUpdate